<template>
  <nav
    class="navbar navbar-expand-lg fixed-top"
    :class="isSticky ? 'sticky-white-nav' : 'top-nav'"
  >
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="box-shadow: none"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link class="navbar-brand logo-style" to="/">
        <img
          src="@/assets/shuzhen-logo.png"
          alt="Bootstrap"
          width="177"
          height="58"
          class="d-inline-block align-text-top"
        />
      </router-link>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li
            class="nav-item"
            v-for="(item, index) in routerLinks"
            :key="index"
            :class="clickRouter == item.path ? 'navbar_bottom' : ''"
          >
            <router-link :to="item.path" custom>
              <a
                class="nav-link"
                :class="clickRouter == item.path ? 'active' : ''"
                @click.prevent="customNavigate(item.path)"
              >
                {{ item.name }}
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script setup>
import {
  onMounted,
  onBeforeUnmount,
  computed,
  reactive,
  ref,
  watch,
  nextTick,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useRouterStore } from "@/stores/router.js";
import throttle from "lodash/throttle";

const routerStore = useRouterStore();
const router = useRouter();
const route = useRoute();

const clickRouter = computed(() => routerStore.routerName);
const { setRouterName } = routerStore;

const routerLinks = reactive([
  { name: "首页", path: "/" },
  { name: "平台简介", path: "/#section1" },
  { name: "产品介绍", path: "/#section4" },
  { name: "应用场景", path: "/#section2" },
  { name: "关于我们", path: "/#section3" },
]);

// 是否显示 sticky 样式
const isSticky = ref(false);
const trackedSections = ref([]);

const getSectionHash = (path) => path.replace("/", "");

const scrollToElement = (hash) => {
  const target = document.querySelector(hash);
  if (!target) {
    return;
  }
  const top = target.getBoundingClientRect().top + window.scrollY - 88;
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: "smooth",
  });
};

const collectSections = () => {
  trackedSections.value = routerLinks
    .filter((item) => item.path !== "/")
    .map((item) => {
      const element = document.getElementById(item.path.replace("/#", ""));
      return {
        path: item.path,
        element,
      };
    })
    .filter((item) => item.element);
};

const updateActiveSection = () => {
  if (window.location.pathname !== "/") {
    return;
  }

  const currentOffset = window.scrollY + 140;
  let activePath = "/";

  trackedSections.value.forEach((section) => {
    if (section.element.offsetTop <= currentOffset) {
      activePath = section.path;
    }
  });

  setRouterName(activePath);
};

const handleScroll = throttle(() => {
  if (window.location.pathname === "/") {
    isSticky.value = window.scrollY > 50;
    if (window.scrollY < 240) {
      setRouterName("/");
      return;
    }
    updateActiveSection();
  } else {
    isSticky.value = true;
  }
}, 100);

onMounted(async () => {
  if (window.location.pathname !== "/") {
    isSticky.value = true;
  }
  await nextTick();
  collectSections();
  handleScroll();
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", collectSections);
});

watch(
  () => route.fullPath,
  async () => {
    await nextTick();
    collectSections();
    handleScroll();
  },
);

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("resize", collectSections);
});

const customNavigate = async (path) => {
  if (path !== "/") {
    isSticky.value = true;
  } else {
    isSticky.value = false;
  }

  if (path === "/") {
    await router.push(path);
    setRouterName(path);
    return;
  }

  const hash = getSectionHash(path);
  setRouterName(path);

  if (route.path === "/" && route.hash === hash) {
    scrollToElement(hash);
    return;
  }

  await router.push({
    path: "/",
    hash,
  });
};
</script>
<style scoped>
.navbar .container-fluid {
  padding-left: 260px;
  padding-right: 260px;
}

.navbar.sticky-white-nav {
  background-color: rgba(255, 255, 255, 1);
}
.navbar.top-nav a {
  color: #000;
}
.navbar.top-nav {
  background-color: rgba(255, 255, 255, 0.3);
}
.navbar:hover {
  background-color: white;
}
.navbar:hover a {
  color: #000;
}
.navbar.sticky-white-nav a {
  color: #000;
}
.nav-item {
  position: relative;
}
.nav-item::after {
  position: absolute;
  left: 0;
  bottom: -3px;
  right: 0;
  height: 4px;
  content: "";
  background-color: #007eff;
  border-radius: 4px;
  opacity: 0;
  transform: scaleX(0);
  transition:
    transform 0.4s,
    opacity 0.4s;
}
.navbar a {
  text-decoration: none;
  cursor: pointer;
}
.navbar_bottom::after {
  opacity: 1;
  transform: scaleX(1);
}

.navbar a {
  color: #fff;
}
.sys-nav-sub-wp {
  height: 0;
  overflow: hidden;
  transition: height 0.6s ease;
  left: 0;
  position: absolute;
  right: unset;
  top: 60px;
  width: 100%;
  z-index: 4;
  background: #fff;
}
.nav-item {
  margin: 0 50px;
  font-size: 14px;
}
.nav-item:hover .sys-nav-sub-wp {
  height: 190px;
  border-top: 1px solid #f4f5f7;
}

.active {
  color: #007eff !important;
  font-weight: 700 !important;
}
.sys-nav-sub-wp .sys-nav-sub a {
  display: inline-block;
  line-height: 24px;
  padding: 0;
  text-align: center;
  transition:
    color 0.3s,
    background-color 0.3s;
  position: relative;
  text-decoration: none;
}
.sys-nav-sub-wp .sys-nav-sub a img {
  width: 160px;
  height: 120px;
  margin: 20px 40px 0;
}
.sys-nav-sub-wp .sys-nav-sub a h4 {
  font-weight: 600;
  font-size: 14px;
  color: #000;
}
.sys-nav-sub-wp .sys-nav-sub a:after {
  content: " ";
  width: 1px;
  height: 120px;
  background: #f4f5f7;
  position: absolute;
  right: 0;
  top: 20px;
}
.logo-style {
  display: flex;
  align-items: center;
  color: #1f7bd6 !important;
  font-weight: 700;
}

@media (max-width: 1200px) {
  .navbar .container-fluid {
    padding-left: 40px;
    padding-right: 40px;
  }

  .nav-item {
    margin: 0 20px;
    font-size: 14px;
  }
}

@media (max-width: 992px) {
  .navbar .container-fluid {
    padding-left: 16px;
    padding-right: 16px;
  }

  .nav-item {
    margin: 0;
    font-size: 3.6vw;
  }

  .nav-link {
    padding: 2vw 0;
  }

  .nav-item::after {
    display: none;
  }
}
</style>
